import React from 'react';

import '../../styles/globals.css';

interface PortalLayoutProps {
  children: React.ReactNode;
}

const PortalLayout: React.FC<PortalLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-[rgb(252,252,252)]">
      {children}
    </div>
  );
};

export default PortalLayout;
